import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";
import GameNotificationPopup from "../components/One-to-one-games/Game-notification-popup/GameNotificationPopup";
import AchievementNotificationModal from "../shared/sharedComponents/AchievementNotificationModal/AchievementNotificationModal";
import GiftPopupModal from "../shared/sharedComponents/GiftPopupModal/GiftPopupModal";
import useActiveMatchListener, {
  isActiveMatchListenerRoute,
} from "../hooks/useActiveMatchListener";
import useHasActiveEventsListener from "../hooks/useHasActiveEventsListener";
import { useDispatch, useSelector } from "react-redux";
import MobileAppAlert from "../shared/sharedComponents/mobile-app-alert/MobileAppAlert";
import { getLocalStorageData } from "../shared/commonFunction";
import { setUser } from "../features/user/userSlice";
import { fetchHasActiveEvents } from "../features/event/eventSlice";

const Layout = () => {
  const isLogin = useSelector((state) => state.login.isLogin);
  const isAds = useSelector((state) => state.ads.isAdsShow);
  const location = useLocation();
  const dispatch = useDispatch();
  const path = location.pathname;
  const listenActiveMatch = isActiveMatchListenerRoute(path);
  useActiveMatchListener(listenActiveMatch);
  useHasActiveEventsListener();

  useEffect(() => {
    const storedUser = JSON.parse(getLocalStorageData("user") || "{}");
    if (storedUser && Object.keys(storedUser).length > 0) {
      dispatch(setUser(storedUser));
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchHasActiveEvents());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname, location.search]);

  // Rest of your component code
  return (
    <div className="bg-color">
      <div className="navbar-mobile-ads">
        {isAds && path === "/" && <MobileAppAlert />}
        {!(path === "/delete-account") ? <Navbar /> : null}
      </div>
      {isLogin && <GameNotificationPopup from="layout" />}
      {isLogin && <AchievementNotificationModal />}
      {isLogin && <GiftPopupModal />}
      <Outlet />
      {!(path === "/delete-account") ? <Footer /> : null}
    </div>
  );
};

export default Layout;
